import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * StageList — vertical sequence of steps (05 §2.7). Each item may carry a
 * one-line judgement (rendered prominently) plus a body.
 */
const StageList = ({ items, start = 1, idPrefix }) => {
  const { t } = useTranslation('cy');
  return (
    <div>
      {items.map((item, i) => (
        <div className="cy-stage" key={i} id={idPrefix ? `${idPrefix}-${i}` : undefined}>
          <div className="cy-stage__num">{String(i + start).padStart(2, '0')}</div>
          <div className="cy-stage__content">
            <h3 className="cy-stage__title">{item.title || item.name}</h3>
            {item.judgement ? <p className="cy-stage__judgement">{item.judgement}</p> : null}
            {item.body || item.io || item.note || item.input || item.role || item.stop || item.continue ? (
              <div className="cy-stage__body">
                {item.body ? <p>{item.body}</p> : null}
                {item.io ? (
                  <p>
                    <strong>{t('ui.stage.io')}</strong> {item.io}
                  </p>
                ) : null}
                {item.input ? (
                  <p>
                    <strong>{t('ui.stage.input')}</strong> {item.input}
                  </p>
                ) : null}
                {item.role ? (
                  <p>
                    <strong>{t('ui.stage.role')}</strong> {item.role}
                  </p>
                ) : null}
                {item.continue ? (
                  <p>
                    <strong>{t('ui.stage.continue')}</strong> {item.continue}
                  </p>
                ) : null}
                {item.stop ? (
                  <p>
                    <strong>{t('ui.stage.stop')}</strong> {item.stop}
                  </p>
                ) : null}
                {item.note ? (
                  <p>
                    <strong>{t('ui.stage.note')}</strong> {item.note}
                  </p>
                ) : null}
              </div>
            ) : null}
          </div>
        </div>
      ))}
    </div>
  );
};

export default StageList;
